import React, { useState, useEffect } from "react"
import {
  has,
  includes,
  pull,
  concat,
  clone,
  forEach,
  merge,
  get,
  map,
} from "lodash"
import ClassNames from "classnames"

import { NEWS_TOGGLE } from "config/const"

export const ToggleFilter = (props: {
  setCategory: Function
  setApiFlag: Function
  resetFlag?: boolean
}) => {
  const [openToggle, setToggle] = useState<Array<number | string>>([])
  const [selectedNewsCategory, setSelectedNewsCategory] = useState(
    map(NEWS_TOGGLE, items => {
      return items.id
    })
  )

  const _setSelectedNewsCategory = (id: number) => {
    let _selectedNewsCategory = clone(selectedNewsCategory)
    let _apiFlag = true
    if (id === 0) {
      if (includes(_selectedNewsCategory, 0)) {
        _apiFlag = false
        _selectedNewsCategory = []
      } else {
        _selectedNewsCategory = map(NEWS_TOGGLE, items => {
          return items.id
        })
      }
    } else {
      pull(_selectedNewsCategory, 0)
      if (includes(_selectedNewsCategory, id)) {
        pull(_selectedNewsCategory, id)
      } else {
        _selectedNewsCategory.push(id)
      }
    }
    props.setApiFlag(_apiFlag)
    setSelectedNewsCategory(_selectedNewsCategory)
  }

  useEffect(() => {
    let apiParam = {}
    if (selectedNewsCategory.length !== NEWS_TOGGLE.length) {
      forEach(selectedNewsCategory, id => {
        if (id === 1 || id === 2) {
          const _source = get(apiParam, "Source", [])
          _source.push(NEWS_TOGGLE[id].key)
          apiParam = merge(apiParam, { Source: _source })
        } else if (id !== 0) {
          const _category = get(apiParam, "Category", [])
          _category.push(NEWS_TOGGLE[id].key)
          apiParam = merge(apiParam, { Category: _category })
        }
      })
    }
    props.setCategory(apiParam)
  }, [selectedNewsCategory])

  useEffect(() => {
    if (props.resetFlag) {
      const _selectedNewsCategory = map(NEWS_TOGGLE, items => {
        return items.id
      })
      setSelectedNewsCategory(_selectedNewsCategory)
    }
  }, [props.resetFlag])

  return (
    <div className="collapse-toggle-lv1 collapse-wrapper">
      <span className="title-border news-category">ニュースカテゴリ</span>
      <ul>
        {NEWS_TOGGLE.map((row, i) => (
          <li
            key={i}
            className="collapse-list"
            onClick={event => {
              event.stopPropagation()
              event.preventDefault()
              _setSelectedNewsCategory(row.id)
            }}
          >
            <div className="collapse-header">
              <label className="checkbox-control">
                <input
                  type="checkbox"
                  className="input-multi-control"
                  checked={includes(selectedNewsCategory, row.id)}
                />
                <span>{row.title}</span>
              </label>
            </div>
            {/* {has(row, "children") &&
              row.children.map((sec, j) => (
                <div
                  key={j}
                  className={ClassNames(
                    "collapse-toggle-contents collapse-toggle-lv2",
                    {
                      "has-toggle": has(sec, "children"),
                      "is-active": includes(openToggle, sec.id),
                    }
                  )}
                >
                  <div className="collapse-toggle-header">
                    <div
                      className="collapse-header"
                      onClick={() => {
                        const cloneArray = clone(openToggle)
                        setToggle(
                          includes(openToggle, sec.id)
                            ? pull(cloneArray, sec.id)
                            : concat(cloneArray, sec.id)
                        )
                        setNewsCategory(i, j)
                      }}
                    >
                      {sec.title}
                      {has(sec, "children") && (
                        <i className="material-icons search-toggle-icon">
                          {includes(openToggle, sec.id)
                            ? "keyboard_arrow_down"
                            : "keyboard_arrow_right"}
                        </i>
                      )}
                    </div>
                  </div>
                  {has(sec, "children") ? (
                    <ul className="collapse-toggle-contents collapse-toggle-lv3">
                      {sec.children.map((thr, k) => (
                        <li key={k} className="collapse-toggle-item">
                          <div className="collapse-header">{thr.title}</div>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              ))} */}
          </li>
        ))}
      </ul>
    </div>
  )
}

export const SpToggleFilter = (props: {
  isVisible: Boolean
  setVisible: Function
  setSelectedNewsCategory: Function
  selectedNewsCategory: Array<number>
}) => {
  return (
    <div
      className={ClassNames("collapse-toggle-lv1 collapse-wrapper isSp", {
        active: props.isVisible,
      })}
    >
      <div className="collapse-toggle-header">
        <span className="title-border news-category">ニュースカテゴリ</span>
        <div className="close-btn">
          <i
            className="material-icons"
            onClick={() => props.setVisible(!props.isVisible)}
          >
            close
          </i>
        </div>
      </div>
      <div className="collapse-toggle-contnets">
        {NEWS_TOGGLE.map((row, i) => (
          <div className="btn-multi-control" key={row.key}>
            <label
              className={ClassNames("btn btn-outline shaped", {
                active: includes(props.selectedNewsCategory, row.id),
              })}
            >
              <input
                type="checkbox"
                className="input-multi-control"
                onClick={event => {
                  event.stopPropagation()
                  event.preventDefault()
                  props.setSelectedNewsCategory(row.id)
                }}
              />
              <span>{row.title}</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

type SearchProps = {
  title: string | React.ReactElement
  children?: React.ReactElement
  active: boolean
  onToggle: () => void
}

export const SearchToggle = (props: SearchProps) => {
  return (
    <div className="search-toggle">
      <div
        className={ClassNames("toggle-header panel-filter-header", {
          "is-active": props.active,
        })}
        onClick={() => props.onToggle()}
      >
        <div className="panel-filter-header-title title-border">
          {props.title}
          {props.children && (
            <i className="material-icons search-toggle-icon">
              {props.active ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            </i>
          )}
        </div>
      </div>
      <div className="toggle-body">{props.children}</div>
    </div>
  )
}
